import { DashboardInstallationData } from '@vi-iot/client/index';
import { DeviceRoles } from '@vi-iot/client/models';

export namespace BrandLogo {
  const brandLogoMap = {
    [DeviceRoles.PrefixViessmann]: '/assets/icons/icon-Viessmann.svg',
    [DeviceRoles.PrefixCarrier]: '/assets/icons/icon-Carrier.svg',
    [DeviceRoles.PrefixToshiba]: '/assets/icons/icon-Toshiba.svg',
    [DeviceRoles.PrefixRiello]: '/assets/icons/icon-Riello.svg',
    [DeviceRoles.PrefixBeretta]: '/assets/icons/icon-Beretta.svg',
  };

  export const getBrandLogo = (deviceRoles: string[]): string | null => {
    const role = deviceRoles?.find((role) => brandLogoMap[role]);

    return brandLogoMap[role] ?? null;
  };

  export function updateDashboardInstallationDataBrandLogo(
    installation: DashboardInstallationData
  ): DashboardInstallationData {
    return {
      ...installation,
      devices: installation.devices.map((device) => {
        return { ...device, brandLogo: getBrandLogo(device.roles) };
      }),
    };
  }
}
